import React from 'react';

const ecommerceServices = [
  {
    id: 'custom-ecommerce',
    platform: 'Headless & Bespoke',
    title: 'Custom E-commerce Development',
    description:
      'Tailor-made e-commerce architectures built from scratch with custom workflows, headless frontend integration, high-concurrency database design, and proprietary business logic for businesses with unique requirements.',
    tags: ['Next.js / React', 'GraphQL / REST APIs', 'Microservices'],
    icon: (
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="16 18 22 12 16 6" />
        <polyline points="8 6 2 12 8 18" />
        <line x1="12" y1="2" x2="12" y2="22" />
      </svg>
    )
  },
  {
    id: 'magento',
    platform: 'Enterprise Adobe Commerce',
    title: 'Magento Development',
    description:
      'Heavy-duty, high-volume multi-store platforms with complex ERP/CRM integrations, advanced B2B quoting engines, custom module development, and lightning-fast Varnish caching for enterprise retailers.',
    tags: ['Multi-Storefront', 'B2B Wholesale', 'ERP Integration'],
    icon: (
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L2 7l10 5 10-5-10-5z" />
        <path d="M2 17l10 5 10-5" />
        <path d="M2 12l10 5 10-5" />
      </svg>
    )
  },
  {
    id: 'bigcommerce',
    platform: 'Scalable Open SaaS',
    title: 'BigCommerce Development',
    description:
      'Enterprise-grade open-SaaS e-commerce engineering with zero server complexity, automated checkout customization, headless storefronts, and cross-channel marketplace management with global scalability.',
    tags: ['Open SaaS', 'Headless Engine', 'Multi-Currency'],
    icon: (
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    )
  },
  {
    id: 'shopify',
    platform: 'High-Converting Stores',
    title: 'Shopify & Shopify Plus Development',
    description:
      'Custom Liquid themes, bespoke Shopify apps, checkout extensibility, seamless migration from legacy platforms, and high-velocity store optimization engineered for maximum sales conversions.',
    tags: ['Shopify Plus', 'Custom Apps', 'Liquid Engine'],
    icon: (
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
        <line x1="3" y1="6" x2="21" y2="6" />
        <path d="M16 10a4 4 0 0 1-8 0" />
      </svg>
    )
  },
  {
    id: 'woocommerce',
    platform: 'WordPress Ecosystem',
    title: 'WooCommerce Development',
    description:
      'Highly flexible WordPress e-commerce stores with bespoke theme development, high-security payment gateways, automated recurring subscriptions, and speed-optimized database queries.',
    tags: ['Custom Plugins', 'Subscriptions', 'Speed Optimized'],
    icon: (
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M8 14s1.5 2 4 2 4-2 4-2" />
        <line x1="9" y1="9" x2="9.01" y2="9" />
        <line x1="15" y1="9" x2="15.01" y2="9" />
      </svg>
    )
  },
  {
    id: 'wix',
    platform: 'Agile & Dynamic',
    title: 'Wix eCommerce Development',
    description:
      'Rapid-to-market, visually captivating storefronts with customized Velo backend scripting, automated booking/inventory synchronization, and seamless multi-channel payment integrations.',
    tags: ['Velo by Wix', 'Inventory Sync', 'Instant Launch'],
    icon: (
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    )
  }
];

function EcommerceServicesGrid() {
  const handleCardClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('ecommerce-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="ecom-services-section">
      <div className="container">
        {/* Section Header */}
        <div className="ecom-services-header">
          <div className="ecom-services-badge-row">
            <span className="ecom-services-badge">Enterprise Store Architectures</span>
            <div className="ecom-services-badge-line"></div>
          </div>

          <h2 className="ecom-services-title">
            Leading <span className="text-red">E-commerce Website Development</span> Services
          </h2>

          <p className="ecom-services-subtitle">
            From custom headless architectures to enterprise store setups, we engineer scalable, high-converting digital storefronts tailored to your brand’s growth goals.
          </p>
        </div>

        {/* 6 Services Grid */}
        <div className="ecom-services-grid">
          {ecommerceServices.map((service) => (
            <div key={service.id} className="ecom-service-card" onClick={handleCardClick}>
              {/* Card Header: Platform Tag & Icon */}
              <div className="ecom-card-top">
                <span className="ecom-platform-tag">{service.platform}</span>
                <div className="ecom-icon-box">
                  {service.icon}
                </div>
              </div>

              {/* Title */}
              <h3 className="ecom-card-title">{service.title}</h3>

              {/* Description */}
              <p className="ecom-card-desc">{service.description}</p>

              {/* Tech Highlights Tags */}
              <div className="ecom-tags-row">
                {service.tags.map((tag, idx) => (
                  <span key={idx} className="ecom-tag-pill">{tag}</span>
                ))}
              </div>

              {/* Action Link at Bottom */}
              <div className="ecom-card-action">
                <span className="ecom-action-text">Discuss this platform</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="ecom-action-arrow">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default EcommerceServicesGrid;
